import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite, ApplicationService,
  InvestorRepresentativeAppEntityInvestorRepresentativeWrite, InvestorRepresentativeService
} from '../openapi';

@Injectable({
  providedIn: 'root'
})
export class InvestorRepresentativeCommonService {
  constructor(
    private applicationService: ApplicationService,
    private investorRepresentativeService: InvestorRepresentativeService
  ) {
  }

  public updateInvestorRepresentative(
    application: ApplicationAppEntityApplicationRead,
    payload: ApplicationAppEntityApplicationWrite,
    investorRepresentatives: InvestorRepresentativeAppEntityInvestorRepresentativeWrite[]
  ): Observable<ApplicationAppEntityApplicationRead> {
    return this.deleteInvestorRepresentativeItems(application?.investorRepresentatives?.map(v => v.uuid || '') || [])
      .pipe(
        switchMap(() => {
          if (investorRepresentatives.length) {
            return forkJoin(investorRepresentatives.map(investorRepresentative => this.investorRepresentativeService.postInverstorRepresentativeInvestorRepresentativeCollection({
              investorRepresentative
            }))).pipe(
              switchMap(items => {
                return this.applicationService.patchApplicationApplicationItem({
                  id: application?.uuid || '',
                  application: { ...payload, investorRepresentatives: items.map(v => v.uuid || '').filter(v => !!v) }
                });
              })
            );
          } else {
            return this.applicationService.patchApplicationApplicationItem({
              id: application?.uuid || '',
              application: payload
            });
          }
        })
      );
  }


  public deleteInvestorRepresentativeItems(ids: string[]): Observable<any> {
    if (!ids.length) {
      return of([]);
    } else {
      return forkJoin(ids.map(id => this.investorRepresentativeService.deleteInverstorRepresentativeInvestorRepresentativeItem({
        id
      })));
    }
  }
}
